import React, { useState } from 'react';

import * as S from './Version.styles';

const Version = () => {
  const [isOpen, setIsOpen] = useState(!!process.env.IS_DEBUG);
  const onToggle = () => setIsOpen(state => !state);

  return (
    <S.Wrapper>
      {isOpen ? (
        <S.Info>
          {`v. ${process.env.VERSION} - (${process.env.ENV}),
            built on ${new Date(process.env.BUILD_DATE).toUTCString()}
          `}
        </S.Info>
      ) : null}
      <S.Button onClick={onToggle}>[ {isOpen ? '-' : '+'} ]</S.Button>
    </S.Wrapper>
  );
};

Version.displayName = 'Version';

export default React.memo(Version);
